import React from 'react'
import {
  handleDates,
  handlePayment,
  formatPriceCents,
} from 'sidecar-utility-library'

import { Icon, RollUp, Info, Toggle, Row, SubRow } from './styles'

const Component = ({
  billingCycleEndDate,
  billingCycleStartDate,
  expanded,
  handleRollUpView,
  subTransactions = [],
  productType,
}) => (
  <RollUp>
    <Info forDates>
      <p>{handleDates({ billingCycleEndDate, billingCycleStartDate })}</p>
    </Info>
    <Toggle onClick={handleRollUpView}>
      <Icon name={expanded ? 'minus' : 'plus'} />{' '}
      <div>{`Split between ${subTransactions.length} types`}</div>
    </Toggle>
    {expanded && (
      <Row>
        {subTransactions.length > 0 &&
          subTransactions.map((subTransaction = {}, index) => (
            <SubRow key={index}>
              <Info>
                <p>
                  {handlePayment({
                    transaction: subTransaction,
                    undefinedTxt: 'Paid',
                    productType,
                  })}
                </p>
              </Info>

              <Info hasValues>
                <p>{formatPriceCents(subTransaction.amount)}</p>
              </Info>
            </SubRow>
          ))}
      </Row>
    )}
  </RollUp>
)

Component.displayName = 'RollUp'

export default Component
